import { motion } from "framer-motion";
import { HeartPulse, Landmark, Truck, ShoppingBag, Scale, Building2, Factory, Plane } from "lucide-react";

const INDUSTRIES = [
  { icon: HeartPulse, name: "Healthcare & Life Sciences", desc: "Patient intake, claims processing, clinical documentation" },
  { icon: Landmark, name: "Finance & Insurance", desc: "KYC automation, fraud signals, report generation" },
  { icon: Truck, name: "Logistics & Supply Chain", desc: "Route intelligence, freight paperwork, demand forecasting" },
  { icon: ShoppingBag, name: "Retail & E-commerce", desc: "Inventory prediction, support agents, personalised offers" },
  { icon: Scale, name: "Legal & Compliance", desc: "Contract review, document intelligence, audit trails" },
  { icon: Building2, name: "Real Estate & Property", desc: "Lead qualification, listing automation, tenant support" },
  { icon: Factory, name: "Manufacturing", desc: "Quality vision systems, predictive maintenance, ERP sync" },
  { icon: Plane, name: "Hospitality & Travel", desc: "Booking agents, guest messaging, dynamic pricing" },
];

export const Industries = () => {
  return (
    <section id="industries" className="relative py-28 lg:py-36 px-6" data-testid="industries-section">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8 }}
          className="mb-16 lg:mb-20 max-w-2xl"
        >
          <p className="text-xs tracking-[0.3em] uppercase text-[#10E59A] mb-5">Chapter 03 — Who we serve</p>
          <h2 className="font-['Outfit'] font-light text-3xl sm:text-4xl lg:text-5xl tracking-tight text-[#E8F1F5]">
            Deep expertise across <span className="gradient-text font-medium">every industry</span>
          </h2>
          <p className="mt-6 text-base leading-relaxed text-[#8AA1B1]">
            Automation is not one-size-fits-all. We bring proven playbooks from the industries
            we work in every day — then tailor them to your currents.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {INDUSTRIES.map((ind, i) => (
            <motion.div
              key={ind.name}
              data-testid={`industry-card-${i}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: (i % 4) * 0.08 }}
              whileHover={{ y: -6 }}
              className="group rounded-2xl border border-[#00F2FE]/15 bg-[#051221]/70 backdrop-blur-sm p-7 hover:border-[#10E59A]/45 hover:shadow-[0_0_30px_-10px_rgba(16,229,154,0.35)] transition-[border-color,box-shadow] duration-500"
            >
              <span className="w-11 h-11 rounded-xl border border-[#00F2FE]/25 bg-[#00F2FE]/5 flex items-center justify-center mb-5 group-hover:bg-[#10E59A]/10 group-hover:border-[#10E59A]/40 transition-[background-color,border-color] duration-300">
                <ind.icon className="w-5 h-5 text-[#00F2FE] group-hover:text-[#10E59A] transition-colors duration-300" />
              </span>
              <h3 className="font-['Outfit'] font-medium text-base text-[#E8F1F5] mb-2">{ind.name}</h3>
              <p className="text-xs leading-relaxed text-[#8AA1B1]">{ind.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
